import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useInstanceId } from '@/contexts/InstanceIdContext';

export const useDataDog = () => {
  const { instanceId } = useInstanceId();

  useEffect(() => {
    if (instanceId) {
      datadogRum.setUser({
        id: instanceId,
      });
    }

    window.onbeforeunload = () => {
      datadogRum.clearUser();
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, [instanceId]);
};
